// @flow
import * as React from 'react'
import shallowEqual from 'mz-utils/shallowEqual'
import { wrapWithField } from '../../Field'
import { authorizeSource } from '../stripe'
import Lightbox from '../../../core/Lightbox'
import RadioField from 'mz-ui-kit/form/RadioField'
import { IframeContainer } from '../NewCreditCardMethod/elements'
import { FormattedMessage } from 'mz-intl'
import messages from '../messages.intl'
import AlipayIcon from '../assets/alipay'
import { ASYNC_PAYMENT_METHOD, PAY_WITH_SOURCE } from '../constants'
import {
  Container,
  BrandContainer,
  ExistingLabel,
} from '../CreditCardItem/elements'

// Types
import type { Input, Meta } from 'mz-ui-kit/core/BaseField'
import type { MethodProps } from '..'

export type Props = MethodProps & {
  input: Input,
  meta: Meta,
}
type State = {
  show3DSecure: boolean,
  threeDSecureURL: string,
}

/**
 * One-button payment method for Alipay
 * @extends React
 */
export class AlipayMethod extends React.Component<Props, State> {
  state = {
    show3DSecure: false,
    threeDSecureURL: '',
  }

  iteration = 0

  cancelAuthTrigger: ?{ cancel: boolean }

  handleCloseSecureIframe = () => {
    this.setState({ show3DSecure: false })
    if (this.cancelAuthTrigger) {
      this.cancelAuthTrigger.cancel = true
    }
  }

  createStripeSource = async () => {
    const { stripe, currency, stripeChargeAmount, config } = this.props
    const activeIteration = ++this.iteration
    const safeSetState = (...args) =>
      activeIteration === this.iteration && this.setState(...args)

    this.cancelAuthTrigger = { cancel: false }

    const result = await authorizeSource({
      stripe,
      currency,
      amount: stripeChargeAmount,
      updateState: safeSetState,
      cancelAuthTrigger: this.cancelAuthTrigger,
      type: 'alipay',
    })

    return {
      type: PAY_WITH_SOURCE,
      source: result,
      origin: config.origin,
      currency,
    }
  }

  render() {
    const { input, shouldSecurePayment } = this.props
    const activeValue = {
      type: ASYNC_PAYMENT_METHOD,
      getOption: this.createStripeSource,
    }
    const active = !!input && shallowEqual(input.value, activeValue)
    const disabled = shouldSecurePayment

    const handleContainerClick = () => {
      const { onChange } = this.props.input
      if (active) {
        return
      }
      onChange && onChange(activeValue)
    }

    return (
      <Container
        $active={active}
        $disabled={disabled}
        onClick={handleContainerClick}
      >
        <RadioField
          {...this.props}
          disabled={disabled}
          activeValue={activeValue}
          inactiveValue={null}
        />
        <BrandContainer>
          <AlipayIcon />
        </BrandContainer>
        <ExistingLabel>
          <FormattedMessage message={messages.PAY_WTH_ALIPAY} />
        </ExistingLabel>
        <Lightbox
          onClose={this.handleCloseSecureIframe}
          showed={this.state.show3DSecure}
          title={{
            mobile: (
              <FormattedMessage message={messages.ALIPAY_LIGHTBOX_TITLE} />
            ),
          }}
          render={() => (
            <div>
              <IframeContainer
                src={this.state.threeDSecureURL || 'about:blank'}
              />
            </div>
          )}
        />
      </Container>
    )
  }
}

export default wrapWithField(AlipayMethod)
